import React from 'react';
import { WebsiteDesignProps } from './types';
import { BookOpen, Feather, Search, Bookmark } from 'lucide-react';
import { Button } from "@/components/ui/button";

const VintageLibrary: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Athenaeum";

    return (
        <div className="bg-[#f4ecd8] text-[#4a3b32] min-h-screen font-serif selection:bg-[#8d6e63] selection:text-white">
            {/* Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-20 z-0" style={{backgroundImage: 'url(https://www.transparenttextures.com/patterns/aged-paper.png)'}}></div>

            <div className="relative z-10 border-b-4 border-double border-[#8d6e63] bg-[#fdfbf7] py-6 shadow-sm">
                <div className="container mx-auto px-8 flex justify-between items-center">
                     <div className="flex items-center gap-3">
                         <BookOpen className="text-[#8d6e63]" size={32} />
                         <div>
                             <h1 className="text-2xl font-bold uppercase tracking-widest text-[#5d4037]">{schoolName}</h1>
                             <div className="text-[10px] text-[#8d6e63] uppercase tracking-[0.4em]">Est. 1892</div>
                         </div>
                     </div>
                     <nav className="hidden md:flex gap-8 text-[#5d4037] font-bold text-sm uppercase tracking-wider">
                         <a href="#" className="hover:text-[#8d6e63] hover:underline decoration-2 underline-offset-4">Catalogue</a>
                         <a href="#" className="hover:text-[#8d6e63] hover:underline decoration-2 underline-offset-4">Membership</a>
                         <a href="#" className="hover:text-[#8d6e63] hover:underline decoration-2 underline-offset-4">Lectures</a>
                     </nav>
                </div>
            </div>

            <main className="relative z-10 container mx-auto px-8 py-16">
                 <div className="bg-[#fdfbf7] p-8 md:p-12 shadow-lg border border-[#e0e0e0] flex flex-col md:flex-row gap-12 items-center rounded-sm">
                     <div className="flex-1">
                         <div className="w-12 h-1 bg-[#8d6e63] mb-6"></div>
                         <h2 className="text-5xl md:text-6xl font-bold text-[#3e2723] mb-6 leading-tight">
                             Where Wisdom <br/> Resides.
                         </h2>
                         <p className="text-lg text-[#6d4c41] leading-relaxed mb-8 italic">
                             "A room without books is like a body without a soul."
                         </p>
                         <div className="flex gap-4">
                             <Button className="bg-[#5d4037] hover:bg-[#3e2723] text-[#f4ecd8] px-8 rounded-sm font-sans uppercase tracking-widest text-xs h-12">
                                 Register
                             </Button>
                             <Button variant="outline" className="border-[#5d4037] text-[#5d4037] hover:bg-[#5d4037] hover:text-[#f4ecd8] px-8 rounded-sm font-sans uppercase tracking-widest text-xs h-12">
                                 Explore
                             </Button>
                         </div>
                     </div>
                     <div className="flex-1 relative">
                         <div className="absolute inset-0 border-4 border-[#8d6e63] transform translate-x-4 translate-y-4"></div>
                         <img src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=2070&auto=format&fit=crop" className="relative z-10 shadow-md sepia-[.3] contrast-125" alt="Library" />
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
                     {[
                         { icon: Feather, title: "The Classics", desc: "Timeless literature for the discerning mind." },
                         { icon: Search, title: "Research", desc: "Access to rare manuscripts and archives." },
                         { icon: Bookmark, title: "Curated", desc: "Expertly selected collections for study." }
                     ].map((item, i) => (
                         <div key={i} className="text-center p-8 bg-[#fdfbf7] border border-[#d7ccc8] shadow-sm hover:shadow-md transition-shadow">
                             <item.icon className="mx-auto text-[#8d6e63] mb-4" size={28} />
                             <h3 className="text-xl font-bold text-[#4e342e] mb-2 uppercase tracking-wide">{item.title}</h3>
                             <p className="text-[#795548] text-sm leading-relaxed">{item.desc}</p>
                         </div>
                     ))}
                 </div>
            </main>
        </div>
    );
};

export default VintageLibrary;
